function base64ToArrayBuffer(base64Data: string): ArrayBuffer {
    //
    const byteCharacters = window.atob(base64Data);
    //
    const byteNumbers = new Array(byteCharacters.length);
    //
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    //
    const byteArray = new Uint8Array(byteNumbers);
    //
    return byteArray.buffer;
}

// ----------------------------------------------------------------------------

export default base64ToArrayBuffer;
